const bookingWidgetHeight = () => {
    // Select all elements with the class 'js-iframe'
    const iframeElements = Array.prototype.slice.call(document.querySelectorAll('.js-booking-iframe'));

    // Check if there are any matching elements
    if (iframeElements.length !== 0) {
        // Add an event listener for the 'message' event
        window.addEventListener('message', function(event) {
            // Check if the origin of the message is 'https://www.sevenrooms.com'
            if (event.origin === 'https://www.sevenrooms.com') {
                // Check if the message type is 'heightEvent'
                if (event.data.type === 'heightEvent') {
                    // Find the matching iframe element and set its height based on the message data
                    iframeElements.find(function(iframe) {
                        return iframe.contentWindow === event.source;
                    }).style.height = event.data.size + 'px';
                }
            }
        });
    }
}

bookingWidgetHeight();

// Recalculate the position if the window is resized
window.addEventListener('resize', bookingWidgetHeight);